import { Nature, Section } from '@mairistem/comptabilite';
import PROFIL_ECRITURE from '../../../constants/mouvements/codeProfilEcritures';
import NATURE_PIECE from '../../../constants/mouvements/naturePiece';
import { TYPE_BORDEREAU } from '../../../constants/mouvements/typeBordereau';
import TYPE_PIECE from '../../../constants/mouvements/typePiece';
import BaseProfilEcritureRecette from './Base/BaseProfilEcritureRecette';
import CompteDeTiersPanel from '../panel/CompteDeTiersPanel';
import CovidPanel from '../panel/CovidPanel';
import DetailDeFacturationPanel from '../panel/DetailDeFacturationPanel';
import EditionAsapDematerialiseePanel from '../panel/EditionAsapDematerialiseePanel';
import PeriodeCouvertePanel from '../panel/PeriodeCouvertePanel';
import ProjetPanel from '../panel/ProjetPanel';

class ProfilEcritureOrdFoncRecette extends BaseProfilEcritureRecette {
  constructor() {
    super();
    this.code = PROFIL_ECRITURE.RECETTE.ORD_FONC;
    this.typeBordereau = TYPE_BORDEREAU.RECETTE.ORDINAIRE;
    this.naturePiece = NATURE_PIECE.RECETTE.FONCTIONNEMENT;
    this.typePiece = TYPE_PIECE.RECETTE.ORDINAIRE;
    this.imputation.section = Section.FONCTIONNEMENT;
    this.imputation.nature = Nature.REEL;
    this.panels = [
      ...this.panels,
      new CompteDeTiersPanel(),
      new CovidPanel(),
      new DetailDeFacturationPanel(),
      new EditionAsapDematerialiseePanel(),
      new PeriodeCouvertePanel(),
      new ProjetPanel(),
    ];
  }
}

export default ProfilEcritureOrdFoncRecette;
